module.exports = __webpack_public_path__ + "img/mobile4.f125bd18.svg";